<mat-card>
  <mat-card-header>
    <mat-card-title>Gestión de {{'Empleado' | translate}}</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>

    <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label *ngIf="!isSearching && msgError?.length > 0">{{msgError}}</mat-label>

    <div *ngIf="!isSearching">

      <ng-container *ngIf="canAdd || canEdit">

        <form [formGroup]="formGroup">

          <!-- DATOS DEL PERSONA -->
          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">person</mat-icon> Datos de Persona
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

              <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center center" class="flex-item" width="100%">
                <mat-expansion-panel [expanded]="true" hideToggle="true" style="background-color: #add5ff;">
                  <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                    <mat-label>
                      ¿Ya tenes cargados los datos de la persona para asociarlos a este empleado?
                    </mat-label>
                  </div>
                  <br />
                  <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                    <button mat-raised-button (click)="onPersonSearchClick()" [disabled]="isProcessing()" color="accent"
                      class="zb-button">Buscar Datos de Persona Existente</button>
                  </div>
                </mat-expansion-panel>
              </div>

            </div>

            <hr style="margin:20px 0px; width: 100%;">

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label>
                      <b># Persona</b>:
                      <ng-container *ngIf="empleado?.PersonaId > 0">
                        <a style="cursor: pointer; margin-right: 5px" (click)="viewPersona(empleado?.PersonaId)">{{empleado?.PersonaId}}</a>
                      </ng-container>
                      <ng-container *ngIf="!(empleado?.PersonaId > 0)">NUEVO</ng-container>
                    </mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 fxLayoutAlign="center center" class="flex-item" style="margin-top: 5px;">
                <button mat-raised-button (click)="onPersonDeassociateClick()" [disabled]="isProcessing()"
                  *ngIf="canDeassociatePerson()" color="warn" class="zb-button">
                  Cargar como Nueva Persona
                </button>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Nombre*</mat-label>
                  <input matInput formControlName="Nombre" (keyup.enter)="onSaveEmpleado()">
                  <mat-error *ngIf="!formGroup.controls['Nombre'].valid && formGroup.controls['Nombre'].touched">
                    {{ getErrorNombre() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Apellido*</mat-label>
                  <input matInput formControlName="Apellido" (keyup.enter)="onSaveEmpleado()">
                  <mat-error *ngIf="!formGroup.controls['Apellido'].valid && formGroup.controls['Apellido'].touched">
                    {{ getErrorApellido() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isTipoDocumentoSearching">Tipo Documento*</mat-label>
                  <mat-label *ngIf="isTipoDocumentoSearching">Cargando...</mat-label>
                  <mat-select formControlName="TipoDocumentoId" (selectionChange)="onTipoDocumentoSelection()">
                    <mat-option>Ninguno</mat-option>
                    <mat-option *ngFor="let s of tipoDocumentoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="!formGroup.controls['TipoDocumentoId'].valid && formGroup.controls['TipoDocumentoId'].touched">
                    {{ getErrorTipoDocumentoId() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Nro. Documento*</mat-label>
                  <input matInput formControlName="NroDocumento" maxlength="100" (change)="onNroDocumentoChange()"
                    (keyup.enter)="onSaveEmpleado()">
                  <mat-error
                    *ngIf="!formGroup.controls['NroDocumento'].valid && formGroup.controls['NroDocumento'].touched">
                    {{ getErrorNroDocumento() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="showCuit">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>CUIT/CUIL</mat-label>
                  <input matInput formControlName="Cuit" type="number" (change)="onCuitChange()"
                    (keyup.enter)="onSaveEmpleado()">
                  <mat-error *ngIf="!formGroup.controls['Cuit'].valid && formGroup.controls['Cuit'].touched">
                    {{ getErrorCuit() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Fecha Nacimiento*</mat-label>
                  <input matInput [matDatepicker]="fechaNacimientoPicker" formControlName="FechaNacimiento"
                    (click)="fechaNacimientoPicker.open()">
                  <mat-error
                    *ngIf="!formGroup.controls['FechaNacimiento'].valid && formGroup.controls['FechaNacimiento'].touched">
                    {{ getErrorFecha() }}
                  </mat-error>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaNacimientoPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaNacimiento')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaNacimientoPicker></mat-datepicker>

                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Mail de Contacto</mat-label>
                  <input matInput formControlName="MailContacto" (keyup.enter)="onSaveEmpleado()" maxlength="255">
                  <mat-error
                    *ngIf="!formGroup.controls['MailContacto'].valid && formGroup.controls['MailContacto'].touched">
                    {{ getErroMailContacto() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Móvil de Contacto*</mat-label>
                  <input matInput formControlName="MovilContacto" (keyup.enter)="onSaveEmpleado()" maxlength="100">
                  <mat-error
                    *ngIf="!formGroup.controls['MovilContacto'].valid && formGroup.controls['MovilContacto'].touched">
                    {{ getErrorMovilContacto() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Móvil de Contacto Otro</mat-label>
                  <input matInput formControlName="MovilContactoOtro" (keyup.enter)="onSaveEmpleado()" maxlength="100">
                  <mat-error
                    *ngIf="!formGroup.controls['MovilContactoOtro'].valid && formGroup.controls['MovilContactoOtro'].touched">
                    {{ getErroMovilContactoOtrol() }}
                  </mat-error>
                </mat-form-field>
              </div>

            </div>

            <hr style="margin:20px 0px; width: 100%;">

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

              <div fxFlex=100 fxFlex.xs=100 class="flex-item" fxLayoutAlign="center" style="margin-bottom: 15px;">
                <mat-label><u><b>Datos Biométricos</b></u></mat-label>
              </div>

              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 12px;">
                    <div fxFlex=90 fxFlex.xs=100 class="flex-item">
                      <a href="{{empleado?.FotoDniFrenteUrl}}" target="_blank" *ngIf="hasPersonaFotoDniFrente()">Ver
                        Foto DNI Frente</a>
                      <mat-label class="text-label" *ngIf="!hasPersonaFotoDniFrente()">
                        <b><i class="fa fa-exclamation-triangle" style="margin-right: 5px;"></i> No tiene imagen de DNI
                          frente</b>
                      </mat-label>
                    </div>
                    <div fxFlex=10 fxFlex.xs=100 class="flex-item" *ngIf="!isImageLoading && canEdit">
                      <a style="cursor: pointer;" (click)="fileInputDniFrente.click()" title="Cargar nueva imagen"><i
                          class="fa fa-upload fa-1x"></i></a>
                      <input class="text-label" hidden type="file" (change)="convertFileToBase64($event, 'DniFrente')"
                        accept="image/*" #fileInputDniFrente>
                    </div>
                  </div>
                </mat-expansion-panel>
              </div>
              <br />
              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 12px;">
                    <div fxFlex=90 fxFlex.xs=100 class="flex-item">
                      <a href="{{empleado?.FotoDniDorsoUrl}}" target="_blank" *ngIf="hasPersonaFotoDniDorso()">Ver Foto
                        DNI Dorso</a>
                      <mat-label class="text-label" *ngIf="!hasPersonaFotoDniDorso()">
                        <b><i class="fa fa-exclamation-triangle" style="margin-right: 5px;"></i> No tiene imagen de DNI
                          dorso</b>
                      </mat-label>
                    </div>
                    <div fxFlex=10 fxFlex.xs=100 class="flex-item" *ngIf="!isImageLoading && canEdit">
                      <a style="cursor: pointer;" (click)="fileInputDniDorso.click()" title="Cargar nueva imagen"><i
                          class="fa fa-upload fa-1x"></i></a>
                      <input class="text-label" hidden type="file" (change)="convertFileToBase64($event, 'DniDorso')"
                        accept="image/*" #fileInputDniDorso>
                    </div>
                  </div>
                </mat-expansion-panel>
              </div>
              <br />
              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 12px;">
                    <div fxFlex=90 fxFlex.xs=100 class="flex-item">
                      <a href="{{empleado?.FotoSelfieUrl}}" target="_blank" *ngIf="hasPersonaFotoSelfie()">Ver Foto
                        Selfie</a>
                      <mat-label class="text-label" *ngIf="!hasPersonaFotoSelfie()">
                        <b><i class="fa fa-exclamation-triangle" style="margin-right: 5px;"></i> No tiene imagen de
                          selfie</b>
                      </mat-label>
                    </div>
                    <div fxFlex=10 fxFlex.xs=100 class="flex-item" *ngIf="!isImageLoading && canEdit">
                      <a style="cursor: pointer;" (click)="fileInputSelfie.click()" title="Cargar nueva imagen"><i
                          class="fa fa-upload fa-1x"></i></a>
                      <input class="text-label" hidden type="file" (change)="convertFileToBase64($event, 'Selfie')"
                        accept="image/*" #fileInputSelfie>
                    </div>
                  </div>
                </mat-expansion-panel>
              </div>

            </div>

          </mat-expansion-panel>

          <br />

          <!-- DATOS DEL EMPLEADO -->
          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">work</mat-icon> Datos de Empleado
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isTipoDocumentoSearching">Estado Civil*</mat-label>
                  <mat-label *ngIf="isTipoDocumentoSearching">Cargando...</mat-label>
                  <mat-select formControlName="EstadoCivilId">
                    <mat-option *ngFor="let s of estadoCivilList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="!formGroup.controls['EstadoCivilId'].valid && formGroup.controls['EstadoCivilId'].touched">
                    {{ getErrorEstadoCivilId() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Legajo*</mat-label>
                  <input matInput formControlName="Legajo" (keyup.enter)="onSaveEmpleado()">
                  <mat-error *ngIf="!formGroup.controls['Legajo'].valid && formGroup.controls['Legajo'].touched">
                    {{ getErrorLegajo() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Fecha de Ingreso*</mat-label>
                  <input matInput [matDatepicker]="fechaIngresoPicker" formControlName="FechaIngreso"
                    (click)="fechaIngresoPicker.open()">
                  <mat-error
                    *ngIf="!formGroup.controls['FechaIngreso'].valid && formGroup.controls['FechaIngreso'].touched">
                    {{ getErrorFecha() }}
                  </mat-error>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaIngresoPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaIngreso')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaIngresoPicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Fecha de Egreso</mat-label>
                  <input matInput [matDatepicker]="fechaEgresoPicker" formControlName="FechaEgreso"
                    (click)="fechaEgresoPicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaEgresoPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaEgreso')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaEgresoPicker></mat-datepicker>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isGremioSearching">Gremio</mat-label>
                  <mat-label *ngIf="isGremioSearching">Cargando...</mat-label>
                  <mat-select formControlName="GremioId">
                    <mat-option>Ninguno</mat-option>
                    <mat-option *ngFor="let s of gremioList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isPaisSearching">Nacionalidad*</mat-label>
                  <mat-label *ngIf="isPaisSearching">Cargando...</mat-label>
                  <mat-select formControlName="PaisId">
                    <mat-option *ngFor="let s of paisList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item" style="margin-top: 20px;">
                <mat-checkbox formControlName="Activo" (keyup.enter)="onSaveEmpleado()" color="primary">Activo
                </mat-checkbox>
              </div>

            </div>

          </mat-expansion-panel>

          <br />
          <!-- DATOS DEL DOMICILIO -->
          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">home</mat-icon> Datos de Domicilio
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Domicilio DNI*</mat-label>
                  <input matInput formControlName="DomicilioDni" (keyup.enter)="onSaveEmpleado()">
                  <mat-error
                    *ngIf="!formGroup.controls['DomicilioDni'].valid && formGroup.controls['DomicilioDni'].touched">
                    {{ getErrorDomicilioDni() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Código Postal DNI*</mat-label>
                  <input matInput formControlName="CodigoPostalDni" (keyup.enter)="onSaveEmpleado()">
                  <mat-error
                    *ngIf="!formGroup.controls['CodigoPostalDni'].valid && formGroup.controls['CodigoPostalDni'].touched">
                    {{ getErrorCodigoPostalDni() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isTipoDocumentoSearching">Provincia*</mat-label>
                  <mat-label *ngIf="isTipoDocumentoSearching">Cargando...</mat-label>
                  <mat-select formControlName="ProvinciaId">
                    <mat-option>Seleccionar</mat-option>
                    <mat-option *ngFor="let s of provinciaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="!formGroup.controls['ProvinciaId'].valid && formGroup.controls['ProvinciaId'].touched">
                    {{ getErrorProvincia() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Localidad/Barrio*</mat-label>
                  <input matInput formControlName="LocalidadBarrio" (keyup.enter)="onSaveEmpleado()">
                  <mat-error
                    *ngIf="!formGroup.controls['LocalidadBarrio'].valid && formGroup.controls['LocalidadBarrio'].touched">
                    {{ getErrorLocalidadBarrio() }}
                  </mat-error>
                </mat-form-field>
              </div>

            </div>

            <hr style="margin:20px 0px; width: 100%;">

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Domicilio Real*</mat-label>
                  <input matInput formControlName="DomicilioReal" (keyup.enter)="onSaveEmpleado()">
                  <mat-error
                    *ngIf="!formGroup.controls['DomicilioReal'].valid && formGroup.controls['DomicilioReal'].touched">
                    {{ getErrorDomicilioReal() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Código Postal Real*</mat-label>
                  <input matInput formControlName="CodigoPostalReal" (keyup.enter)="onSaveEmpleado()">
                  <mat-error
                    *ngIf="!formGroup.controls['CodigoPostalReal'].valid && formGroup.controls['CodigoPostalReal'].touched">
                    {{ getErrorCodigoPostalReal() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isTipoDocumentoSearching">Provincia Real*</mat-label>
                  <mat-label *ngIf="isTipoDocumentoSearching">Cargando...</mat-label>
                  <mat-select formControlName="ProvinciaRealId">
                    <mat-option>Seleccionar</mat-option>
                    <mat-option *ngFor="let s of provinciaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="!formGroup.controls['ProvinciaRealId'].valid && formGroup.controls['ProvinciaRealId'].touched">
                    {{ getErrorProvinciaReal() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Localidad/Barrio Real*</mat-label>
                  <input matInput formControlName="LocalidadBarrioReal" (keyup.enter)="onSaveEmpleado()">
                  <mat-error
                    *ngIf="!formGroup.controls['LocalidadBarrioReal'].valid && formGroup.controls['LocalidadBarrioReal'].touched">
                    {{ getErrorLocalidadReal() }}
                  </mat-error>
                </mat-form-field>
              </div>

            </div>

          </mat-expansion-panel>

          <br />
          <!-- DOCUMENTOS -->
          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">attach_file</mat-icon> Documentos
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column" *ngFor="let file of empleado.Documentos"
              style="margin: 5px;">

              <div fxFlex=30 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Descripción</mat-label>
                  <input matInput [(ngModel)]="file.Descripcion" [ngModelOptions]="{standalone: true}" maxlength="150">
                </mat-form-field>
              </div>
              <div fxFlex=65 fxFlex.xs=95 class="flex-item" style="margin-top: 20px;">
                <a matLine href="{{file.UrlDocumento}}" target="_blank">{{file.NombreDocumento}}</a>
              </div>
              <div fxFlex=5 fxFlex.xs=5 class="flex-item" style="margin-top: 10px;">
                <button mat-icon-button (click)="onFileAttachedDelete(file)" title="Eliminar adjunto">
                  <i class="fa fa-trash fa-1x"></i>
                </button>
              </div>

            </div>

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=30 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Descripción</mat-label>
                  <input matInput [(ngModel)]="newFileDescripcion" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
              </div>
              <div fxFlex=70 fxFlex.xs=100 class="flex-item" style="margin-top: 10px;">
                <button mat-icon-button matSuffix (click)="fileInput.click()" [disabled]="isFileAttaching">
                  <mat-icon style="margin-right: 5px;">attach_file</mat-icon> Agregar adjunto
                </button>
                <input hidden (change)="onNewFileAttach($event)" #fileInput type="file">
                <mat-label *ngIf="isFileAttaching"><br /><i class="fa fa-spinner fa-spin"></i> Subiendo archivo...
                </mat-label>
              </div>

            </div>

          </mat-expansion-panel>

          <br />
          <!-- DATOS CONTABLES -->
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">attach_money</mat-icon> Datos Contables
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column">
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Categoria*</mat-label>
                  <input matInput formControlName="Titulo" (keyup.enter)="onSaveEmpleado()">
                  <mat-error *ngIf="!formGroup.controls['Titulo'].valid && formGroup.controls['Titulo'].touched">
                    {{ getErrorNombre() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Puesto*</mat-label>
                  <input matInput formControlName="Posicion" (keyup.enter)="onSaveEmpleado()">
                  <mat-error *ngIf="!formGroup.controls['Posicion'].valid && formGroup.controls['Posicion'].touched">
                    {{ getErrorNombre() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Remuneracion Neta*</mat-label>
                  <input matInput formControlName="RemuneracionNeta" (keyup.enter)="onSaveEmpleado()">
                  <mat-error
                    *ngIf="!formGroup.controls['RemuneracionNeta'].valid && formGroup.controls['RemuneracionNeta'].touched">
                    {{ getErrorNombre() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Remuneracion Extra*</mat-label>
                  <input matInput formControlName="RemuneracionExtra" (keyup.enter)="onSaveEmpleado()">
                  <mat-error
                    *ngIf="!formGroup.controls['RemuneracionExtra'].valid && formGroup.controls['RemuneracionExtra'].touched">
                    {{ getErrorNombre() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item" style="margin-top: 20px;">
                <mat-checkbox formControlName="Aguinaldo" (keyup.enter)="onSaveEmpleado()" color="primary">Corresponde
                  Aguinaldo</mat-checkbox>
              </div>
            </div>

          </mat-expansion-panel>

          <br />
          <!-- DATOS DE CONVIVIENTE -->
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">person</mat-icon> Datos de Conviviente
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Apellido Conviviente</mat-label>
                  <input matInput formControlName="ApellidoConviviente" (keyup.enter)="onSaveEmpleado()">
                  <mat-error
                    *ngIf="!formGroup.controls['ApellidoConviviente'].valid && formGroup.controls['ApellidoConviviente'].touched">
                    {{ getErrorNombre() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Nombre Conviviente</mat-label>
                  <input matInput formControlName="NombreConviviente" (keyup.enter)="onSaveEmpleado()">
                  <mat-error
                    *ngIf="!formGroup.controls['NombreConviviente'].valid && formGroup.controls['NombreConviviente'].touched">
                    {{ getErrorNombre() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>DNI Conviviente</mat-label>
                  <input matInput formControlName="DniConviviente" (keyup.enter)="onSaveEmpleado()">
                  <mat-error
                    *ngIf="!formGroup.controls['DniConviviente'].valid && formGroup.controls['DniConviviente'].touched">
                    {{ getErrorNombre() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Cantidad Hijos A Cargo</mat-label>
                  <input matInput formControlName="CantHijosACargo" (keyup.enter)="onSaveEmpleado()">
                  <mat-error
                    *ngIf="!formGroup.controls['CantHijosACargo'].valid && formGroup.controls['CantHijosACargo'].touched">
                    {{ getErrorNombre() }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

          </mat-expansion-panel>

          <br />
          <!-- DATOS DE SUBCONTRATISTA -->
          <mat-expansion-panel [expanded]="true" *ngIf="tenantFeatureFlags?.HabilitarControlPedidos">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">group</mat-icon> Datos de Subcontratista
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isSubContratistaSearching">Subcontratista</mat-label>
                  <mat-label *ngIf="isSubContratistaSearching">Cargando...</mat-label>
                  <input type="text" placeholder="Apellido o Nombre - Cuit" aria-label="SubContratista" matInput
                    formControlName="Subcontratista" [matAutocomplete]="subContratista">
                  <i [ngStyle]="{'display': isSubContratistaSearching ? 'inline-block' : 'none'}"
                    class="fa fa-spinner fa-spin" style="position: absolute; right: 0"></i>
                  <mat-error
                    *ngIf="!formGroup.controls['Subcontratista'].valid && formGroup.controls['Subcontratista'].touched">
                    {{ getErrorSubcontratista() }}
                  </mat-error>
                  <mat-autocomplete [displayWith]="displaySubContratista" autoActiveFirstOption
                    #subContratista="matAutocomplete" (optionSelected)="comprobarEmpleados()">
                    <mat-option *ngFor="let s of filteredEmpleadoList" [value]="s">
                      {{s.Apellido | uppercase}} {{s.Nombre | uppercase}} - {{s.Cuit}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>

            <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;"
              *ngIf="empleadoList != undefined && empleadoList?.length > 0">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label style="margin-top: 15px; font-weight: 500;">Listado de Empleados del Subcontratista:
                </mat-label>
              </div>
            </div>

            <ejs-grid *ngIf="empleadoList != undefined && empleadoList?.length > 0" #grid [dataSource]='dataEmpleados'
              [locale]="es-LA" [allowPaging]="true" [allowSorting]="true" [query]='query'
              [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'>
              <e-columns>
                <e-column field='Nombre' headerText='Empleado' width=200>
                  <ng-template #template let-data>
                    {{data.Nombre + " " + data.Apellido}}
                  </ng-template>
                </e-column>
                <e-column field='Cuit' headerText='CUIT' width=200></e-column>
                <e-column field='GremioNombre' headerText='Gremio' width=120></e-column>
              </e-columns>
            </ejs-grid>

          </mat-expansion-panel>

        </form>

        <br />
        <!-- DATOS DE OBRAS -->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">location_city</mat-icon> Datos de Asignación de {{'Comunidad' | translate}}
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <form [formGroup]="comunidadForm">

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}</mat-label>
                  <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                  <mat-select formControlName="Comunidad">
                    <mat-option>Seleccionar</mat-option>
                    <mat-option *ngFor="let s of comunidadList" [value]="s">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="!comunidadForm?.controls['Comunidad'].valid && comunidadForm?.controls['Comunidad'].touched">
                    {{ getErrorComunidad() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Fecha Inicio</mat-label>
                  <input matInput [matDatepicker]="fechaInicioPicker" formControlName="FechaInicio"
                    (click)="fechaInicioPicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaInicioPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearObraDate('FechaInicio')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaInicioPicker></mat-datepicker>
                  <mat-error
                    *ngIf="!comunidadForm?.controls['FechaInicio'].valid && comunidadForm?.controls['FechaInicio'].touched">
                    {{ getErrorFechaInicio() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Fecha Fin</mat-label>
                  <input matInput [matDatepicker]="fechaFinPicker" formControlName="FechaFin"
                    (click)="fechaFinPicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaFinPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearObraDate('FechaFin')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaFinPicker></mat-datepicker>
                </mat-form-field>
              </div>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <button mat-raised-button (click)="onSaveObra()" [disabled]="isProcessing()" color="primary"
                  class="zb-button">Guardar {{'Comunidad' | translate}}</button>
              </div>

            </div>

          </form>

          <hr style="margin:20px 0px; width: 100%;">

          <ejs-grid style="margin-left: 10px; margin-right: 10px;" #comunidadGrid [dataSource]='empleado?.Comunidades'
            [locale]="es-LA" [allowPaging]="true" [allowSorting]="true" [query]='query'
            [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'>
            <e-columns>
              <e-column field='ComunidadNombre' headerText='Obra' width=100>
                <ng-template #headerTemplate let-data>
                  <mat-label>{{'Comunidad' | translate}}</mat-label>
                </ng-template>
                <ng-template #template let-data>
                  <mat-label>{{data.ComunidadNombre}}</mat-label>
                </ng-template>
              </e-column>
              <e-column field='FechaInicio' headerText='Fecha Inicio' width=70>
                <ng-template #template let-data>
                  <mat-label>{{data.FechaInicio | date:'dd/MM/yyyy'}}</mat-label>
                </ng-template>
              </e-column>
              <e-column field='FechaFin' headerText='Fecha Fin' width=70>
                <ng-template #template let-data>
                  <mat-label>{{data.FechaFin | date:'dd/MM/yyyy'}}</mat-label>
                </ng-template>
              </e-column>
              <e-column headerText='Acciones' textAlign='center' width=80>
                <ng-template #template let-data>
                  <a style="cursor: pointer; margin-right: 5px" (click)="onComunidadEdit(data)" title="Ver asignación">
                    <i class="fa fa-eye"></i>
                  </a>
                  <a style="cursor: pointer; margin-right: 5px" (click)="onComunidadDelete(data)" title="Eliminar asignación">
                    <i class="fa fa-trash"></i>
                  </a>
                </ng-template>
              </e-column>
            </e-columns>
          </ejs-grid>

        </mat-expansion-panel>

      </ng-container>

      <ng-container *ngIf="!canEdit">

        <!-- DATOS DEL PERSONA -->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">person</mat-icon> Datos de Persona
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngIf="empleado != null">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Nombre</b>: {{empleado.Nombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Apellido</b>: {{empleado.Apellido}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Tipo Documento</b>: {{empleado.TipoDocumentoNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Nro. Documento</b>: {{empleado.NroDocumento}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>CUIT/CUIL</b>: {{empleado.Cuit}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Fecha Nacimiento</b>: {{empleado.FechaNacimiento | date:'dd/MM/yyyy'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Nacionalidad</b>: {{empleado.PaisNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Mail de Contacto</b>: {{empleado.MailContacto}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Móvil de Contacto</b>: {{empleado.MovilContacto}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Móvil de Contacto Otro</b>: {{empleado.MovilContactoOtro}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

          <hr style="margin:20px 0px; width: 100%;">

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item" fxLayoutAlign="center" style="margin-bottom: 15px;">
              <mat-label><u><b>Datos Biométricos</b></u></mat-label>
            </div>

            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 12px;">
                  <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                    <a href="{{empleado?.FotoDniFrenteUrl}}" target="_blank" *ngIf="hasPersonaFotoDniFrente()">Ver Foto
                      DNI Frente</a>
                    <mat-label class="text-label" *ngIf="!hasPersonaFotoDniFrente()">
                      <b><i class="fa fa-exclamation-triangle" style="margin-right: 5px;"></i> No tiene imagen de DNI
                        frente</b>
                    </mat-label>
                  </div>
                </div>
              </mat-expansion-panel>
            </div>
            <br />
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 12px;">
                  <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                    <a href="{{empleado?.FotoDniDorsoUrl}}" target="_blank" *ngIf="hasPersonaFotoDniDorso()">Ver Foto
                      DNI Dorso</a>
                    <mat-label class="text-label" *ngIf="!hasPersonaFotoDniDorso()">
                      <b><i class="fa fa-exclamation-triangle" style="margin-right: 5px;"></i> No tiene imagen de DNI
                        dorso</b>
                    </mat-label>
                  </div>
                </div>
              </mat-expansion-panel>
            </div>
            <br />
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 12px;">
                  <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                    <a href="{{empleado?.FotoSelfieUrl}}" target="_blank" *ngIf="hasPersonaFotoSelfie()">Ver Foto
                      Selfie</a>
                    <mat-label class="text-label" *ngIf="!hasPersonaFotoSelfie()">
                      <b><i class="fa fa-exclamation-triangle" style="margin-right: 5px;"></i> No tiene imagen de
                        selfie</b>
                    </mat-label>
                  </div>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

        </mat-expansion-panel>

        <br />
        <!-- DATOS DEL EMPLEADO -->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">work</mat-icon> Datos de Empleado
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Estado Civil</b>: {{empleado.EstadoCivilNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Legajo</b>: {{empleado.Legajo}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Fecha de Ingreso</b>: {{empleado.FechaIngreso | date:'dd/MM/yyyy'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Fecha de Egreso</b>: {{empleado.FechaEgreso | date:'dd/MM/yyyy'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Gremio</b>: {{empleado.GremioNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Activo</b>: {{empleado.Activo ? 'Si' : 'No'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

        </mat-expansion-panel>

        <br />
        <!-- DATOS DEL DOMICILIO -->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">home</mat-icon> Datos de Domicilio
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Domicilio DNI</b>: {{empleado.DomicilioDni}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Código Postal DNI</b>: {{empleado.CodigoPostalDni}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Provincia</b>: {{empleado.ProvinciaNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Localidad/Barrio</b>: {{empleado.LocalidadBarrio}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

          <hr style="margin:20px 0px; width: 100%;">

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Domicilio Real</b>: {{empleado.DomicilioReal}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Código Postal Real</b>: {{empleado.CodigoPostalReal}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Provincia Real</b>: {{empleado.ProvinciaRealNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Localidad/Barrio Real</b>: {{empleado.LocalidadBarrioReal}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

        </mat-expansion-panel>

        <br />
        <!-- DOCUMENTOS -->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">attach_file</mat-icon> Documentos
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;" *ngIf="isAttachmentSearching">
              <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
            </div>
            <ejs-grid style="margin-left: 10px; margin-right: 10px;" #documentosGrid [dataSource]='empleado.Documentos'
              [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
              [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'
              *ngIf="!isAttachmentSearching">
              <e-columns>
                <e-column field='Descripcion' headerText='Descripción' width=80></e-column>
                <e-column field='UrlDocumento' headerText='Adjunto'>
                  <ng-template #template let-data>
                    <a matLine href="{{data.UrlDocumento}}" target="_blank">{{data.NombreDocumento}}</a>
                  </ng-template>
                </e-column>
              </e-columns>
            </ejs-grid>

          </div>

        </mat-expansion-panel>

        <br />
        <!-- DATOS CONTABLES -->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">attach_money</mat-icon> Datos Contables
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Categoria</b>: {{empleado.Titulo}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Puesto</b>: {{empleado.Posicion}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Remuneración Neta</b>: {{empleado.RemuneracionNeta | number:'1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Remuneración Extra</b>: {{empleado.RemuneracionExtra | number:'1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Corresponde Aguinaldo</b>: {{empleado.CorrespondeAguinaldo ? 'Si' : 'No'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
          </div>

        </mat-expansion-panel>

        <br />
        <!-- DATOS DE CONVIVIENTE -->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">person</mat-icon> Datos de Conviviente
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Apellido Conviviente</b>: {{empleado.ApellidoConviviente}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Nombre Conviviente</b>: {{empleado.NombreConviviente}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>DNI Conviviente</b>: {{empleado.DniConviviente}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Cantidad Hijos A Cargo</b>: {{empleado.CantHijosACargo}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
          </div>

        </mat-expansion-panel>

        <br />
        <!-- DATOS DE SUBCONTRATISTA -->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">group</mat-icon> Datos de Subcontratista
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Subcontratista</b>:
                    {{subcontratista ? subcontratista?.Nombre + " " + subcontratista?.Apellido + " - " + subcontratista?.Cuit : ""}}
                  </mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;" *ngIf="isSubContratistaSearching">
              <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
            </div>
            <ejs-grid *ngIf="empleadoList != undefined && empleadoList?.length > 0"
              style="margin-left: 10px; margin-right: 10px;" #empleadosGrid [query]="query" [dataSource]='dataEmpleados'
              [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
              [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'>
              <e-columns>
                <e-column field='Nombre' headerText='Empleado' width=200>
                  <ng-template #template let-data>
                    {{data.Nombre + " " + data.Apellido}}
                  </ng-template>
                </e-column>
                <e-column field='Cuit' headerText='CUIT' width=200></e-column>
                <e-column field='GremioNombre' headerText='Gremio' width=120></e-column>
              </e-columns>
            </ejs-grid>

          </div>

        </mat-expansion-panel>

        <br />
        <!-- DATOS DE OBRAS -->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">location_city</mat-icon> Datos de Asignación de {{'Comunidad' | translate}}
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;" *ngIf="isObraSearching">
              <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
            </div>

            <ejs-grid *ngIf="empleado?.Comunidades?.length > 0" style="margin-left: 10px; margin-right: 10px;"
              #comunidadGrid [dataSource]='empleado?.Comunidades' [locale]="es-LA" [allowPaging]="true"
              [allowSorting]="true" [query]='query' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
              [allowResizing]='true'>
              <e-columns>
                <e-column field='ComunidadNombre' headerText='Comunidad' width=100>
                  <ng-template #headerTemplate let-data>
                    <mat-label>{{ 'Comunidad' | translate}}</mat-label>
                  </ng-template>
                  <ng-template #template let-data>
                    <mat-label>{{data.ComunidadNombre}}</mat-label>
                  </ng-template>
                </e-column>
                <e-column field='FechaInicio' headerText='Fecha Inicio' width=70>
                  <ng-template #template let-data>
                    <mat-label>{{data.FechaInicio | date:'dd/MM/yyyy'}}</mat-label>
                  </ng-template>
                </e-column>
                <e-column field='FechaFin' headerText='Fecha Fin' width=70>
                  <ng-template #template let-data>
                    <mat-label>{{data.FechaFin | date:'dd/MM/yyyy'}}</mat-label>
                  </ng-template>
                </e-column>
              </e-columns>
            </ejs-grid>

          </div>

        </mat-expansion-panel>

      </ng-container>

    </div>

  </mat-card-content>

  <mat-card-actions style="margin-bottom: 20px;">
    <div fxLayout="row stretch" fxLayout.xs="column">
      <button mat-raised-button (click)="onSaveEmpleado()" *ngIf="canEdit" [disabled]="isProcessing()" color="primary"
        class="zb-button">{{isEmpleadoSaving ? 'Guardando...' : 'Guardar'}}</button>
      <button mat-raised-button (click)="onCancel()" color="warn"
        class="zb-button">{{canEdit ? 'Cancelar' : 'Cerrar'}}</button>
      <button mat-raised-button (click)="onDelete()" *ngIf="canDelete && empleado != null && empleado.Id > 0"
        [disabled]="isProcessing()" color="warn" class="zb-button">
        {{isDeleting ? 'Eliminando...' : 'Eliminar'}}
      </button>
    </div>
  </mat-card-actions>

</mat-card>
